/**
 * Conta atual da mesa — SOMENTE LEITURA.
 *
 * Não cobra, não fecha mesa, não altera pagamento nem emite recibo.
 * Os dados vêm de GET /public/table-assist/bill, isolado por
 * restaurant_id + table_id + table_session_id no servidor.
 */
export function TableHubBill({ bill, loading, error, statusMessage, payment, paymentLoading,
  paymentError, onPay, onClose, fmt, themeColor = "#f97316" }) {
  const items = bill?.items || [];
  const discount = Number(bill?.discount_total || 0);

  return (
    <div
      className="fixed inset-0 z-[1200] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm"
      style={{ pointerEvents: "auto" }}
      data-testid="table-hub-bill"
    >
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-3xl max-h-[88vh] flex flex-col shadow-2xl">
        <div className="px-5 pt-5 pb-3 border-b border-gray-100">
          <p className="text-[11px] font-semibold tracking-[0.18em] text-gray-400 uppercase">
            {bill?.table_name || "Tu cuenta"}
          </p>
          <h2 className="text-xl font-bold text-gray-900">Tu cuenta</h2>
          {statusMessage && (
            <p className="mt-2 text-sm font-semibold" style={{ color: themeColor }} data-testid="table-hub-bill-status">
              {statusMessage}
            </p>
          )}
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {loading && <p className="text-sm text-gray-500">Cargando tu cuenta…</p>}
          {!loading && error && <p className="text-sm text-red-600">{error}</p>}
          {!loading && !error && items.length === 0 && (
            <p className="text-sm text-gray-500">Todavía no hay productos en esta mesa.</p>
          )}
          {!loading && !error && items.length > 0 && (
            <ul className="divide-y divide-gray-100">
              {items.map((item, idx) => (
                <li key={`${item.order_id}-${idx}`} className="flex items-start justify-between gap-3 py-2.5">
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">{item.product_name}</p>
                    <p className="text-xs text-gray-400">{item.quantity} × {fmt(item.unit_price)}</p>
                  </div>
                  <span className="text-sm font-semibold text-gray-900 shrink-0">{fmt(item.subtotal)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="px-5 py-4 border-t border-gray-100 space-y-2">
          {discount > 0 && (
            <div className="flex items-center justify-between text-sm text-emerald-600" data-testid="table-hub-bill-discount">
              <span>Descuentos</span>
              <span>-{fmt(discount)}</span>
            </div>
          )}
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-500">Total actual</span>
            <span className="text-2xl font-bold" style={{ color: themeColor }} data-testid="table-hub-bill-total">
              {fmt(Number(bill?.total || 0))}
            </span>
          </div>
          {payment?.status === "paid" ? (
            <div className="rounded-xl bg-emerald-50 p-3 text-center font-semibold text-emerald-700"
              data-testid="table-payment-paid">Pago confirmado. ¡Gracias!</div>
          ) : ["ready", "checkout_created"].includes(payment?.status) ? (
            <>
              <button type="button" onClick={onPay} disabled={paymentLoading}
                className="w-full h-14 rounded-xl text-white font-bold disabled:opacity-60"
                style={{ backgroundColor: themeColor }} data-testid="table-payment-pay">
                {paymentLoading ? "ABRIENDO PAGO…" : "PAGAR CUENTA COMPLETA"}
              </button>
              <p className="text-center text-xs font-medium text-gray-700">
                Una persona paga el total completo de la mesa.
              </p>
              <p className="text-center text-[11px] text-gray-500">
                Pago seguro con Viva. Apple Pay y Google Pay según disponibilidad del dispositivo.
              </p>
            </>
          ) : (
            <p className="text-[11px] text-gray-500">
              Esperando a que el equipo acepte la cuenta para habilitar el pago.
            </p>
          )}
          {paymentError && <p className="text-sm text-red-600">{paymentError}</p>}
          <button
            type="button"
            onClick={onClose}
            className="w-full h-12 rounded-xl border-2 font-semibold transition hover:opacity-80"
            style={{ borderColor: `${themeColor}60`, color: themeColor }}
            data-testid="table-hub-bill-close"
          >
            Volver
          </button>
        </div>
      </div>
    </div>
  );
}
